import { Fragment, useContext } from "react";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import BusinessOverviewList from "../../container/BusinessOverview/BusinessOverviewList";
import { useLocation, useNavigate } from "react-router-dom";
import NonIdealNew from "../../common/NonIdealNew";
import withObservables from "@nozbe/with-observables";
import { BusinessOverviewTransactionsCount } from "../../../database/helpers/invoice";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { PlayIcon } from "../../../assets/icons/icon";
import ActivateWalletNudge from "../../common/ActivateWalletNudge";
import styles from "./businessOverview.module.css"

const BusinessOverview = ({ businessOverviewTransactionsListCount }) => {
  const [I18n] = useContext(LanguageContext);
  const location = useLocation();
  const navigate = useNavigate();
  const isNonIdeal = businessOverviewTransactionsListCount == 0;

  const handleAddQuickSaleOrExpense = (type) => {
    triggerLogEvent(analytics, "quick_sale_create");
    navigate(
      type == "in" ? "/QuickSale/QuickSaleForm" : "/Expense/ExpenseForm",
      {
        state: {
          pathname: location.pathname,
        },
      },
    );
  };

  return (
    <MainContainer fluid className={`quickSalePage ${styles.businessOverviewMainContainer}`}>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox data={{ title: I18n.businessoverview,className:styles.title }}>
            {isNonIdeal && (
              <Fragment>
                <UBButton
                  onClick={() => handleAddQuickSaleOrExpense("out")}
                  id="addContactButton"
                  className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
                  title={I18n.add_expense}
                />
                <UBButton
                  onClick={() => handleAddQuickSaleOrExpense("in")}
                  id="addContactButton"
                  className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
                  title={I18n.add_sale}
                />
              </Fragment>
            )}
          </TitleAndActionBox>
          <ActivateWalletNudge className={styles.walletNudge} />
          {isNonIdeal ? (
            <InnerWrapper className="innerWrapper newInnerWrapper">
              <NonIdealNew
                title={`${I18n.sales}, ${I18n.expenses}, ${I18n.profits}`}
                subtitle={
                  I18n.Add_salesexpenses_to_see_your_PL_and_grow_your_profits
                }
                button1Title="add_expense"
                // button2Title="watch_video"
                onButton1Click={() => handleAddQuickSaleOrExpense("out")}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"create_expense"}
                listButton2Title="add_sale"
                onListButton2Click={() => handleAddQuickSaleOrExpense("in")}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_footer={{
                  title: I18n.add_sale,
                  onClick: () => handleAddQuickSaleOrExpense("in"),
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={`${I18n.sales}, ${I18n.expenses}, ${I18n.profit}`}
                videoSubtitle={
                  I18n.Add_salesexpenses_to_see_your_PL_and_grow_your_profits
                }
              />
            </InnerWrapper>
          ) : (
            <InnerWrapper className={styles.businessOverviewWrapper}>
              <BusinessOverviewList />
            </InnerWrapper>
          )}
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  businessOverviewTransactionsListCount: BusinessOverviewTransactionsCount(
    localStorage.getItem("business_id"),
  ),
}));

export default enhance(BusinessOverview);
